import { BasePagePath } from 'app/core/workflow/page-path/base-page.path';

export class PrivacyPolicyPagePath extends BasePagePath {
  public static path(): string {
    return 'privacy-policy';
  }
}
